import { render, staticRenderFns } from "./Grafico.vue?vue&type=template&id=9bf3ded4"
import script from "./Grafico.vue?vue&type=script&lang=js"
export * from "./Grafico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports